import BasicLayout from '../layouts/BasicLayout';
import Home from '../pages/Home';
import NotFound from '../pages/NotFound';

import NumberPlate from '../pages/QrScanner/NumberPlate';
import TicketNumber from '../pages/QrScanner/TicketNumber';
import FindMyCarByQrScanner from '../pages/FindMyCar/FindMyCar';
import PosPayment from '../pages/PosPayment/PosPayment';
import PosPaymentStatus from '../pages/PosPayment/PaymentStatus';
import Services from '../pages/Services/Services';
import Details from '../pages/UserDetails/UserDetails';
import AddVasTicket from '../pages/QrScanner/AddVasTicket';
import Settings from '../pages/Settings/Settings';
import Invoice from '../pages/PosPayment/invoice';

export default [
  {
    path: '/',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },

  {
    path: '/services',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Services />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/addVas',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <AddVasTicket />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/settings',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Settings />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/userDetails',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Details />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },

  {
    path: '/pospayment',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <PosPayment />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/invoice',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Invoice />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/pospaymentstatus',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <PosPaymentStatus />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },

  {
    path: '/findmycarstation',
    element: <BasicLayout />,
    children: [
      {
        path: '/findmycarstation/findmycar',
        element: <FindMyCarByQrScanner />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },

  {
    path: '/numberplate',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <NumberPlate />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/ticketnumber',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <TicketNumber />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];
